import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { AllFreezingResponseModel, AllSoakingResponseModel, assignSoakingForFreezingResponse, FreezingDto, JobCompletedStatusDto, SoakingDto } from '@gtpl/shared-models/production-management';
import { UnitRequest } from './dto/unit.id.request';
import { FreezingService } from './freezing.service';

@ApiTags('freezing')
@Controller('freezing')
export class FreezingController {

    constructor(
        private freezingService: FreezingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/getAssignForFreezingData')
    async getAssignForFreezingData(@Body() plantReq: UnitRequest): Promise<AllSoakingResponseModel>  {
        try {
            return await this.freezingService.getAssignForFreezingData(plantReq.unitId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllSoakingResponseModel, error);
        }
    }

    @Post('/getAssignForFreezingInvData')
    async getAssignForFreezingInvData(@Body() plantReq: UnitRequest): Promise<AllFreezingResponseModel>  {
        try {
            return await this.freezingService.getAssignForFreezingInvData(plantReq.unitId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllFreezingResponseModel, error);
        }
    }


    @Post('/assignSoakingForFreezing')
    async assignSoakingForFreezing(@Body() soakingInfo: FreezingDto): Promise<assignSoakingForFreezingResponse>  {
        try {
            return await this.freezingService.assignSoakingForFreezing(soakingInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
        }
    }

    @Post('/jobCompletedStatus')
    async jobCompletedStatus(@Body() soakingInfo: SoakingDto): Promise<assignSoakingForFreezingResponse>  {
        try {
            return await this.freezingService.jobCompletedStatus(soakingInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
        }
    }
}
